import { RootState } from '@store';
import { createSelector } from 'reselect';
import { LIPState, initState } from '@store/reducers/lip.reducer';
import { isEmpty } from 'lodash';
const lipSlice = (state: RootState) => state?.lip || initState;
export const selectEsignPopUpState = createSelector([lipSlice], (slice: LIPState): string => slice.esignPopUpState);
export const selectSelctedDisclosureUser = createSelector([lipSlice], (slice: LIPState): string => slice.selctedDisclosureUser);

export const lipTileSlice = (state: RootState) => state?.lipTile || initState;
export const selectLipTile = createSelector([lipTileSlice], (data: any) => {
    if (!isEmpty(data)) {
        return data.lipTileResponse;
    }
});

export const selectParent = createSelector(lipSlice, slice => slice.parent);
